<template>
    <v-app>
        <loading-bar />
        <toolbar v-if="restrictedRoute && user.authenticated && user.id" />
        <sidebar v-if="restrictedRoute && user.authenticated && user.id" />

        <v-main style="overflow: auto;">
            <router-view />
        </v-main>

        <alert></alert>
    </v-app>
</template>

<script>
import { mapState } from "pinia";
import { useUserStore } from "@/stores/user";
import * as Sentry from "@sentry/vue";
import Sidebar from "./components/Sidebar.vue";
import Toolbar from "./components/Toolbar.vue";
import Alert from "./components/Alert.vue";
import LoadingBar from "./components/LoadingBar.vue";

export default {
    data() {
        return {
            restrictedRoute: false,
        };
    },
    components: {
        Sidebar,
        Toolbar,
        Alert,
        LoadingBar,
    },
    computed: {
        ...mapState(useUserStore, ["user"]),
    },
    watch: {
        $route() {
            this.restrictedRoute = window.restrictedRoute;
        },
        '$vuetify.theme.global.name'() {
            this.recreateSentryWidget();
        },
    },
    methods: {
        recreateSentryWidget() {
            if (this._sentryWidget) {
                this._sentryWidget.removeFromDom();
                this._sentryWidget = null;
            }
            const feedback = Sentry.getFeedback();
            if (feedback) {
                this._sentryWidget = feedback.createWidget({
                    colorScheme: this.$vuetify.theme.global.name === 'dark' ? 'dark' : 'light',
                });
            }
        },
    },
    mounted() {
        this.restrictedRoute = window.restrictedRoute;
        this.recreateSentryWidget();
    },
};
</script>
<style>
.scrolldiv::-webkit-scrollbar {
    display: none;
}

.scrolldiv {
    -ms-overflow-style: none;
    /* IE 10+ */
    scrollbar-width: none;
    /* Firefox */
}

/* Container: restore Vuetify 2 max-width centering on large screens */
.v-main .v-container {
    max-width: 1785px;
}

</style>